import BaseApi from './BaseApi'

class PaginationApi extends BaseApi {
  getPaginatedData (baseUrl, additionalQueryArr = []) {
    let url = baseUrl
    const params = additionalQueryArr.join('&')
    if (params) {
      url += `?${params}`
    }
    return this.get(url)
  }
}

export default new PaginationApi()
